import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import type { ReactNode } from 'react';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import { usePageNavigation } from '../../hooks/usePageNavigation';
import './CTAButtonList.css';

export type CTAButtonListProps = {
  config?: any; // TODO: tyoes here
  children?: ReactNode;
  className?: string;
};

export function CTAButtonList({
  config,
  children,
  className,
}: CTAButtonListProps) {
  const { __t } = useTranslation();
  const { goToPage, goToNextPage, goToPrevPage } = usePageNavigation();

  return (
    <div className={`cta-btn-list ${className ?? null}`}>
      {typeof children !== 'undefined' && children}
      {config &&
        config.buttons.map((btnConfig: any, index: number) => {
          btnConfig = {
            ...__t(`buttons.${btnConfig.buttonType}`, 'GENERAL'),
            ...btnConfig,
          };
          // console.log(
          //   'btnConfig',
          //   btnConfig,
          //   `buttons.${btnConfig.buttonType}`,
          //   __t(`buttons.${btnConfig.buttonType}`, 'GENERAL')
          // );
          const { buttonType, action, targetPage, url, ...compiledBtnConfig } =
            btnConfig;
          return (
            <CTAButton
              key={index}
              {...compiledBtnConfig}
              onClick={() => {
                switch (action) {
                  case 'link':
                    window.location.href = url;
                    break;
                  case 'goToPage':
                    goToPage(targetPage);
                    break;
                  case 'goToPrevPage':
                    goToPrevPage();
                    break;
                  case 'goToNextPage':
                    goToNextPage();
                    break;
                  default:
                    console.error(
                      'No action assigned for ctaButtonList.buttons',
                      buttonType,
                      compiledBtnConfig
                    );
                    break;
                }
              }}
            />
          );
        })}
    </div>
  );
}
